import React from "react";

// Renders the Network tab inside the bottom panel. Each row shows method,
// direction, URL, status (allowed/blocked/pending) and optional risk badges.
export default function NetworkLogPanel({ logs, texts }) {
  const t = texts && texts.network ? texts.network : null;
  const L = {
    empty: (t && t.empty) || "通信記録はありません",
    method: (t && t.method) || "M",
    dir: (t && t.direction) || "DIR",
    url: (t && t.url) || "URL",
    status: (t && t.status) || "状態",
    sensitiveTip: (t && t.sensitiveTip) || "機密情報の可能性",
    highEntropyTip: (t && t.highEntropyTip) || "高エントロピー値を検出",
    cspTip: (t && t.cspTip) || "CSPによりブロック"
  };

  const dirLabel = (d) => (d === "outbound" ? "OUT" : d === "inbound" ? "IN" : (d || "—"));
  const rawStatus = (s) => s || "—";

  return (
    <div className="nlog-content">
      {logs.length === 0 ? (
        <div className="nlog-empty">{L.empty}</div>
      ) : (
        logs.map((log, i) => (
          <div key={`net-${i}`} className={`nlog-row nlog-${rawStatus(log.status)} nlog-${log.direction}`}>
            <span className="nlog-ts">{new Date(log.timestamp || Date.now()).toLocaleTimeString()}</span>
            <span className="nlog-dir">{dirLabel(log.direction)}</span>
            <span className="nlog-method">{log.method || "—"}</span>
            <span className="nlog-url" title={log.url}>{log.url || "—"}</span>
            <span className={`nlog-status nlog-status-${rawStatus(log.status)}`}>{rawStatus(log.status)}</span>
            <span className="nlog-badges">
              {log.riskBadge && (
                <span className="nlog-badge nlog-badge-sensitive" title={L.sensitiveTip}>⚠</span>
              )}
              {log.badge === "high-entropy" && (
                <span className="nlog-badge nlog-badge-entropy" title={L.highEntropyTip}>E</span>
              )}
              {log.violatedDirective && (
                <span className="nlog-badge nlog-badge-csp" title={L.cspTip}>CSP</span>
              )}
            </span>
          </div>
        ))
      )}
    </div>
  );
}